import { trackUploadBehavior } from '~/utils/report';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const historyStore = useRouteHistory();
  const { $isPure } = useNuxtApp();

  trackUploadBehavior(to.path);

  /** 首次进入没有name */
  if (from.name) {
    historyStore.value.push({
      name: from.name,
      path: from.path,
      fullPath: from.fullPath,
      query: from.query as unknown as Record<string, string | null>,
      params: from.params as unknown as Record<string, string>,
    });
  }

  if (to.name === 'login') {
    setPageLayout($isPure ? false : 'exposed');
  }
});
